import { useContext, useMemo } from 'react';
import { toTTSConfig } from '@trinity/chat/types/tts-config';
import { AuthorContext } from '@trinity/chat-components/components/Chat/context';
import { useGroupFeatures } from './hooks';

export const useIsDemoGroup = () => {
  return false;
};

export const useGroupId = () => {
  const author = useContext(AuthorContext);
  return author?.group?.id;
};

export const useHasWorkspacesEnabled = () => {
  const features = useGroupFeatures();
  return features.workspaces;
};

export const useHasHcpProfilesEnabled = () => {
  const features = useGroupFeatures();
  return features.hcpProfiles;
};

export const useHasChatVoiceInputEnabled = () => {
  const features = useGroupFeatures();
  return features.chatVoiceInput;
};

export const useHasChatReadAloudEnabled = () => {
  const features = useGroupFeatures();
  return features.chatReadAloud;
};

export const useHasChatVoiceModeEnabled = () => {
  const features = useGroupFeatures();
  return features.chatVoiceMode;
};

export const useChatVoiceSource = () => {
  const features = useGroupFeatures();
  return features.chatVoiceSource;
};

export const useChatInteractionModes = () => {
  const features = useGroupFeatures();
  return useMemo(
    () => ({
      available: features.chatInteractionAvailableModes,
      default: features.chatInteractionDefaultMode,
    }),
    [features.chatInteractionAvailableModes, features.chatInteractionDefaultMode]
  );
};

export const useChatLiveAvatarOptions = () => {
  const features = useGroupFeatures();
  return useMemo(
    () => ({
      enabled: features.chatLiveAvatar,
      avatarId: features.chatLiveAvatarId,
      ttsConfig: toTTSConfig(features.chatLiveAvatarTtsConfig),
    }),
    [features.chatLiveAvatar, features.chatLiveAvatarId, features.chatLiveAvatarTtsConfig]
  );
};

export const useHasPredictiveScheduling = () => {
  const features = useGroupFeatures();
  return features.predictiveScheduling;
};

export const useHasSmartRouting = () => {
  const features = useGroupFeatures();
  return features.smartRouting;
};

export const useEngagementLabels = () => {
  const features = useGroupFeatures();
  return features.engagementResponseLabels;
};
